module.exports = __webpack_public_path__ + "static/bgHeroMantenimiento-f60d805348b5571377d5a4ce5e7362fd.jpg";